import { UploadSimple } from '@phosphor-icons/react';
import React, { useState } from 'react';
import { UploadModal } from './DataSidebar/UploadModal';
import { ExtendedSidebar } from './ExtendedSidebar';
import { PlusMenu } from './PlusMenu';
import { SearchAction } from './SearchAction';

export const DataActions: React.FC = () => {
  const [uploadModalOpen, setUploadModalOpen] = useState(false);

  return (
    <>
      <PlusMenu allowedTypes={['object', 'vectorMemory']} />
      <ExtendedSidebar.ActionButton
        icon={UploadSimple}
        onClick={() => setUploadModalOpen(true)}
      />
      <SearchAction />
      <UploadModal
        open={uploadModalOpen}
        onClose={() => setUploadModalOpen(false)}
      />
    </>
  );
};
